import gift from '../../assets/pages/rewards/gift.png';
import { useReferralReward } from '../../helpers/hooks/useReferralReward';

const ReferCard = () => {
  const { ticketsText, pointsText, summaryText } = useReferralReward();
  const headline = [ticketsText, pointsText].filter(Boolean).join(' · ');

  return (
    <div className='relative w-full flex justify-center items-center'>
      <div className='absolute bottom-1 left-1/2 translate-x-[-50%] w-[80%] h-[60px] rounded-[20px] shadow-[0px_12px_50px_0px_#0055FF] z-0 pointer-events-none'></div>
      <div className='relative z-5 w-full flex-shrink-0 rounded-[20px] border-[2px] border-[#E9EDF9] bg-gradient-to-b from-white/0 to-[#D0D5E6]/60 bg-[#FDFEFF] shadow-inner shadow-[#F0F2F9] px-[20px] py-[32px]'>
        <div className='flex flex-col items-center gap-5'>
          <span className='text-main text-center text-[22px] leading-normal tracking-[0.22px]'>
            Refer friends & get
          </span>
          <div
            className='w-[100px] h-[100px] aspect-square bg-center bg-cover bg-no-repeat'
            style={{ backgroundImage: `url(${gift})` }}
          ></div>
          {headline ? (
            <span className='text-primary text-[28px] font-bold leading-normal tracking-[0.56px]'>
              {headline}
            </span>
          ) : null}
          <span className='text-light/50 text-center text-[16px] font-medium leading-[18px] tracking-[0.14px]'>
            {summaryText
              ? `Invite a friend and you’ll get ${summaryText} when they sign up and successfully complete their first rent payment.`
              : 'Invite a friend and earn rewards when they sign up and successfully complete their first rent payment.'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ReferCard;
